import { IconDefinition } from "@fortawesome/fontawesome-svg-core"

import { faIcon } from "@utils/faIcon"

import { TableDataType } from "@organisms/Table/Table.types"

interface getTableSortingIconArgs {
    dataType: TableDataType
    ascending: boolean
}

export default function getTableSortingIcon(args: getTableSortingIconArgs): IconDefinition | undefined {
    const { dataType, ascending } = args

    if (dataType === "alphabetical" && ascending) {
        return faIcon({ name: "arrow-down-a-z", style: "regular" })
    } else if (dataType === "alphabetical" && !ascending) {
        return faIcon({ name: "arrow-up-z-a", style: "regular" })
    } else if (dataType === "numerical" && ascending) {
        return faIcon({ name: "arrow-down-1-9", style: "regular" })
    } else if (dataType === "numerical" && !ascending) {
        return faIcon({ name: "arrow-up-9-1", style: "regular" })
    } else if (dataType === "timing" && ascending) {
        return faIcon({ name: "arrow-down-short-wide", style: "regular" })
    } else if (dataType === "timing" && !ascending) {
        return faIcon({ name: "arrow-up-wide-short", style: "regular" })
    } else if (dataType === "other" && ascending) {
        return faIcon({ name: "arrow-down-short-wide", style: "regular" })
    } else if (dataType === "other" && !ascending) {
        return faIcon({ name: "arrow-up-wide-short", style: "regular" })
    } else if (!dataType && ascending) {
        return faIcon({ name: "arrow-down-short-wide", style: "regular" })
    } else if (!dataType && !ascending) {
        return faIcon({ name: "arrow-up-wide-short", style: "regular" })
    } else {
        return undefined
    }
}
